import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { CardFragmentCommonProps } from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/CardFragment";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import LoadingCardFragment from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/LoadingCardFragment/LoadingCardFragment";
import styles from "./BannerFieldCardFragment.module.css";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { getTypedValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";
import {
  useFormatFieldValue,
  type FieldFormat,
} from "@coworker/apprestructured/src/task-management/hooks/useFormatFieldValue";

export type BannerFieldCardFragmentConfigProps = {
  field: string;
  format?: FieldFormat;
};

type BannerFieldCardFragmentProps = {
  configProps: BannerFieldCardFragmentConfigProps;
  commonProps: CardFragmentCommonProps;
};

function BannerFieldCardFragment({
  configProps,
  commonProps,
}: BannerFieldCardFragmentProps) {
  const { task } = commonProps;
  const { field, format } = configProps;
  const formatFieldValue = useFormatFieldValue();

  const rawValue = getTypedValue<string>(getByPath(task, field));

  if (isLoading(task) || isLoading(rawValue)) {
    return <LoadingCardFragment />;
  }

  if (!rawValue) {
    return null;
  }

  const value = formatFieldValue(rawValue, format);

  return (
    <FixaText textStyle="Body.M" className={styles["root"]}>
      {value}
    </FixaText>
  );
}

export default BannerFieldCardFragment;
